<template>
    <router-view></router-view>
    <debt-collector-form />
</template>

<script>
    import { useInvoiceStore } from '../../stores/InvoiceStore.js'
    import debtCollectorForm from '../DebtCollectorFormComponent'
    export default {
        props: {
            invoice: {
                type: [Array, Object]
            }
        },
        components: {
            debtCollectorForm
        },
        mounted() {
        },
        setup(props) {
            useInvoiceStore().invoice = props.invoice;
        }
    }
</script>
